module.exports = __webpack_public_path__ + "../resources/img/ic_edit.bf1131cd.svg";